import { getAPI, postAPI } from "../../api/api"
import { REACT_APP_JOB, REACT_APP_CUSTOMERSETTINGS } from "../../utils/common"

export async function getJobDetails(jobId: string) {
    const details = getAPI(REACT_APP_JOB + `/position/${jobId}`)
    return details
}

export async function listUserDetailsForCustomer(customerId: string) {
    const Details = getAPI(REACT_APP_CUSTOMERSETTINGS + `/customer-user-details/${customerId}`)
    return Details
}


export async function getEmailBodyHTML(body: any) {
    const Details = postAPI(REACT_APP_JOB + `/job-application-emailhtml`, body);
    return Details
}
